import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { hindiConstants } from "./constants/constants_hi";
import { englishConstants } from "./constants/constants_en";

const resources = {
        en: {
            translation: englishConstants
        },
        hi: {
            translation: hindiConstants  
        },
    }
const DETECTION_OPTIONS = {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage']
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: resources,
    detection: DETECTION_OPTIONS,
  });

export default i18n;